// src/design-system/faIcons.tsx
/** أيقونات FontAwesome Solid حقيقية (مسارات SVG مستخرجة من الحزمة الرسمية
 * @fortawesome/free-solid-svg-icons) — مطلوبة لأن Lucide (خطوط فقط) لا يقدر يطابق
 * شكل الأيقونات المملوءة (solid) المستخدَم في تصميم كروت المؤشرات المرجعي. */
import type { SVGProps } from "react";

type FaIconProps = SVGProps<SVGSVGElement> & { size?: number };

function makeFaIcon(viewBoxW: number, viewBoxH: number, path: string) {
  return function FaIcon({ size = 18, ...rest }: FaIconProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${viewBoxW} ${viewBoxH}`}
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...rest}
      >
        <path d={path} />
      </svg>
    );
  };
}

export const FaBuilding = makeFaIcon(
  384,
  512,
  "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 448 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0L32 32zM64 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM80 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM80 320c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm80 48l0 96 64 0 0-96c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z",
);

export const FaLandmark = makeFaIcon(
  512,
  512,
  "M255.9 0c5.6 0 11.2 1.2 16.4 3.5l211 93.8c9 4 15.8 12.3 17.5 22.1c.6 3.3 .9 6.6 .9 10c0 17.6-14.5 32-32 32L32 161.4C14.5 161.4 0 147 0 129.4c0-3.4 .3-6.7 .9-10c1.6-9.8 8.5-18.1 17.5-22.1l211-93.8C244.6 1.2 250.2 0 255.9 0zM256 80a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM64 224l64 0 0 224 40 0 0-224 64 0 0 224 48 0 0-224 64 0 0 224 40 0 0-224 64 0 0 224 24 0c8.8 0 16 7.2 16 16l0 16c0 8.8-7.2 16-16 16L24 480c-8.8 0-16-7.2-16-16l0-16c0-8.8 7.2-16 16-16l24 0 0-224z",
);

export const FaWallet = makeFaIcon(
  512,
  512,
  "M64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L72 128c-13.3 0-24-10.7-24-24S58.7 80 72 80l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64 32zM416 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z",
);

export const FaWrench = makeFaIcon(
  512,
  512,
  "M481.9 32.4c9.5 7.1 12.9 19.8 8.3 30.7l-48 112c-3.6 8.4-11.6 14-20.7 14.5s-17.7-4-22.6-11.6L353.6 96l-77.3 103.1c8.4 15.1 6.5 34.4-5.5 47.6c-9.2 10.2-24.3 12.9-36.5 6.6c-13.4-7-21.9-21.1-21.9-36.5c0-22.7 18.4-41.1 41.1-41.1c3.6 0 7.1 .5 10.5 1.4l72.8-97.1c-3.2-.6-6.3-1.9-9.1-3.9C305 61.8 289.4 48 271.9 48c-53 0-96 43-96 96c0 12.2 2.3 23.8 6.4 34.6L45.6 314.4C16.4 343.6 0 383.3 0 424.8C0 471.8 40.2 512 87.2 512c41.4 0 81.2-16.4 110.4-45.6L332.4 331.4c10.8 4.1 22.4 6.4 34.6 6.4c53 0 96-43 96-96c0-17.5-13.8-33.1-31.1-45.4c-2-1.4-4.2-2.6-6.4-3.4l97.1-72.8c.9 3.4 1.4 6.9 1.4 10.5c0 22.7-18.4 41.1-41.1 41.1c-15.4 0-29.5-8.5-36.5-21.9c-6.3-12.2-3.6-27.3 6.6-36.5c13.2-12 32.5-13.9 47.6-5.5L481.9 32.4zM64 424a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z",
);

export const FaReceipt = makeFaIcon(
  512,
  512,
  "M164.2 5.1c9.6-6.9 22.6-6.7 32 .5L256 54.1 313.8 5.6c9.4-7.2 22.4-7.4 32-.5l57.6 41.4L461 5.6c9.4-7.2 22.4-7.4 32-.5s13.5 19 10.4 30.6L448 448l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0L8.6 35.7C5.5 24.1 9.9 11.9 19.4 5.1s22.4-6.9 32-.5L109 46.6 164.2 5.1zM144 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM128 320c0 8.8 7.2 16 16 16l224 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-224 0c-8.8 0-16 7.2-16 16z",
);

export const FaArrowUp = makeFaIcon(
  384,
  512,
  "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.3 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z",
);

export const FaArrowDown = makeFaIcon(
  384,
  512,
  "M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.7 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z",
);
